export const messages = {
  en: {
    affiliateRuleManage: {
      queryCondition: 'Query Conditions',
      query: 'Query',
      affiliateRule: 'Affiliate Rule',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      save: 'Save',
      cancel: 'Cancel',
      ruleId: 'Rule ID',
      ruleName: 'Rule Name',
      ruleNamePlaceholder: 'Please enter rule name',
      level1Rate: 'Level 1 Rate',
      level1RatePlaceholder: 'Please enter level 1 rate',
      level2Rate: 'Level 2 Rate',
      level2RatePlaceholder: 'Please enter level 2 rate',
      level21Rate: 'Level 2-1 Rate',
      level21RatePlaceholder: 'Please enter level 2-1 rate',
      expireDay: 'Expire Day',
      expireDayPlaceholder: 'Please enter expire days',
      day: 'Day',
      state: 'Status',
      operation: 'Operation',
      enabled: 'Enabled',
      disabled: 'Disabled',
      confirmOperation: 'Please confirm your operation',
      confirmDelete: 'Are you sure to delete rule',
      confirmDeleteBtn: 'Confirm Delete',
      saveSuccess: 'Save successfully',
      updateSuccess: 'Update successfully',
      deleteSuccess: 'Delete successfully',
      ruleNameRequired: 'Rule name is required',
      ruleNameMaxLength: 'Rule name cannot exceed 30 characters',
      level1RateRequired: 'Level 1 rate is required',
      level1RateMaxLength: 'Level 1 rate cannot exceed 32 characters',
      level2RateRequired: 'Level 2 rate is required',
      level21RateRequired: 'Level 2-1 rate is required',
      expireDayRequired: 'Expire day is required',
      expireDayMaxLength: 'Expire day cannot exceed 200 characters',
      ruleIdRequired: 'Rule ID is required'
    }
  },
  zh: {
    affiliateRuleManage: {
      queryCondition: '查询条件',
      query: '查询',
      affiliateRule: '分销规则',
      add: '添加',
      edit: '修改',
      delete: '删除',
      save: '保存',
      cancel: '取消',
      ruleId: '规则ID',
      ruleName: '规则名称',
      ruleNamePlaceholder: '请输入规则名称',
      level1Rate: '一级分销佣金比例',
      level1RatePlaceholder: '请输入一级分销佣金比例',
      level2Rate: '二级分销佣金比例',
      level2RatePlaceholder: '请输入二级分销佣金比例',
      level21Rate: '二级时一级佣金比例',
      level21RatePlaceholder: '请输入二级时一级佣金比例',
      expireDay: '过期时间',
      expireDayPlaceholder: '请输入过期天数',
      day: '天',
      state: '状态',
      operation: '操作',
      enabled: '启用',
      disabled: '禁用',
      confirmOperation: '请确认您的操作',
      confirmDelete: '确定删除规则',
      confirmDeleteBtn: '确认删除',
      saveSuccess: '保存成功',
      updateSuccess: '更新成功',
      deleteSuccess: '删除成功',
      ruleNameRequired: '规则名称不能为空',
      ruleNameMaxLength: '规则名称不能超过30个字符',
      level1RateRequired: '一级分销佣金比例不能为空',
      level1RateMaxLength: '一级分销佣金比例不能超过32个字符',
      level2RateRequired: '二级分销佣金比例不能为空',
      level21RateRequired: '二级时一级佣金比例不能为空',
      expireDayRequired: '过期时间不能为空',
      expireDayMaxLength: '过期时间不能超过200个字符',
      ruleIdRequired: '规则ID不能为空'
    }
  }
}